import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { SPACE_MINIMUM, SPACE_COMPACT } from '@/styles';

export const mimirLozengeStyles = css`
  background-color: ${token('color.background.accent.orange.subtlest')};
  border-radius: 4px;
  color: ${token('color.text.accent.orange')};
  padding: ${SPACE_MINIMUM}px ${SPACE_COMPACT}px;
  font-size: 13px;
  font-weight: 600;
  margin-left: ${SPACE_MINIMUM}px;
`;
